module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chances-risks",
    class: {
      vertical: _vm.data.vertical
    }
  }, [_c('table', {
    staticClass: "chances"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm._.get(_vm.data, 'chancesLabel', 'Chancen')))])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.chances), function(chance, key) {
    return _c('tr', {
      key: key
    }, [_vm._m(0, true), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(chance)
      }
    })])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "risks"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm._.get(_vm.data, 'riskLabel', 'Risiken')))])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.risks), function(risk, key) {
    return _c('tr', {
      key: key
    }, [_vm._m(1, true), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(risk)
      }
    })])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d2fa158"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockChancesRisks.vue
// module id = 688
// module chunks = 0